import * as React from 'react';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';

import Container from './Container';
import BasicCard from './BasicCard';

const DataCard = ({data, isLoading, fieldId, handleOpen}) => {

    if(isLoading){

        return(
            <Container>
                <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                    <CircularProgress />
                </Box>
            </Container>
        )

    };
  
    return (

        <Container>

            {
                data.length <= 0 ?

                    <Card sx={{ minWidth: 275, mb: 1, minHeight: 180, boxShadow: 0, bgcolor: 'transparent' }}>
                        <CardContent sx={{ display: 'flex', justifyContent: 'center' }}>
                            <Typography color='text.secondary'>
                                Não há linhas
                            </Typography>
                        </CardContent>
                    </Card>
                 
                :

                (
                  
                  <Box
                    sx={{
                        maxHeight: '60vh',
                        overflow: 'auto',
                    }}
                  >
                    
                    {

                        data.map((item) => {
                            return <BasicCard key={item[fieldId]} sr={item} handleOpen={handleOpen}/>
                        })


                    }

                    {/* <Box sx={{ minHeight: '10px'}}>

                    </Box> */}

                  </Box>

                )
            }

        </Container>

    );
};

export default DataCard;
